import { render, staticRenderFns } from "./DateQuick.vue?vue&type=template&id=1fbfceac&"
import script from "./DateQuick.vue?vue&type=script&lang=js&"
export * from "./DateQuick.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports